import { instance } from './instance'

export const gamificationService = {
  // ─── Roulette ─────────────────────────────────────────
  createRouletteGame(data) {
    return instance.post('/roulette', data)
  },
  joinRouletteGame(gameId, data) {
    return instance.post(`/roulette/${gameId}/join`, data)
  },
  spinRoulette(gameId, data) {
    return instance.post(`/roulette/${gameId}/spin`, data)
  },
  finishRoulette(gameId) {
    return instance.post(`/roulette/${gameId}/finish`)
  },
  getRouletteGame(gameId) {
    return instance.get(`/roulette/${gameId}`)
  },
  getActiveRouletteForSession(sessionId) {
    return instance.get(`/roulette/session/${sessionId}`)
  },
  getActiveRouletteForTable(tableId) {
    return instance.get(`/roulette/table/${tableId}`)
  },
  sendWebRTCSignal(gameId, data) {
    return instance.post(`/roulette/${gameId}/signal`, data)
  },
  getWebRTCSignals(gameId, identifier) {
    return instance.get(`/roulette/${gameId}/signals/${identifier}`)
  },

  // ─── Smart Margin Upselling ───────────────────────────
  getSmartUpsell(productIds) {
    return instance.post('/gamification/smart-upsell', { productIds })
  },

  // ─── Prisoner's Dilemma ───────────────────────────────
  checkPrisonerDilemma(tableId) {
    return instance.post('/gamification/prisoner-dilemma', { tableId })
  },

  // ─── Tinder for Food (KI-Fragen) ─────────────────────
  startFoodSwipe(data) {
    return instance.post('/gamification/food-swipe/start', data)
  },
  submitSwipeResults(swipeSessionId, likedIds, dislikedIds) {
    return instance.post(`/gamification/food-swipe/${swipeSessionId}/results`, { likedIds, dislikedIds })
  },

  // ─── Lucky Wheel (Solo-Spiel) ─────────────────────────
  spinLuckyWheel(data) {
    return instance.post('/gamification/lucky-wheel/spin', data)
  },

  // ─── Quiz Battle ──────────────────────────────────────
  startQuiz(data) {
    return instance.post('/gamification/quiz/start', data)
  },
  answerQuiz(quizId, data) {
    return instance.post(`/gamification/quiz/${quizId}/answer`, data)
  },
  getQuiz(quizId) {
    return instance.get(`/gamification/quiz/${quizId}`)
  },

  // ─── Guest Profile ───────────────────────────────────
  createGuestProfile(data) {
    return instance.post('/gamification/guest-profile', data)
  },
  getGuestProfile(deviceFingerprint) {
    return instance.get('/gamification/guest-profile', { params: { deviceFingerprint } })
  },

  // ─── AI Chat ──────────────────────────────────────────
  sendChatMessage(data) {
    return instance.post('/gamification/chat', data)
  },
  getChatHistory(sessionId) {
    return instance.get(`/gamification/chat/${sessionId}`)
  },
  getChatSuggestions() {
    return instance.get('/gamification/chat-suggestions')
  },

  // ─── Battle Royale ────────────────────────────────────
  getActiveDrop() {
    return instance.get('/battle-royale/active')
  },
  claimDrop(dropId, data) {
    return instance.post(`/battle-royale/${dropId}/claim`, data)
  },
  createDrop(data) {
    return instance.post('/battle-royale/drops', data)
  },
  getDropHistory() {
    return instance.get('/battle-royale/history')
  },

  // ─── Mini-Games (Rush Hour, Golden Pour, Flambé, Shell) ──
  createMiniGameSession(data) {
    return instance.post('/minigames/session', data)
  },
  joinMiniGame(sessionId, data) {
    return instance.post(`/minigames/${sessionId}/join`, data)
  },
  startMiniGame(sessionId) {
    return instance.post(`/minigames/${sessionId}/start`)
  },
  submitMiniGameScore(sessionId, data) {
    return instance.post(`/minigames/${sessionId}/score`, data)
  },
  finishMiniGame(sessionId) {
    return instance.post(`/minigames/${sessionId}/finish`)
  },
  getMiniGameSession(sessionId) {
    return instance.get(`/minigames/${sessionId}`)
  },
  getActiveMiniGameForTable(tableId) {
    return instance.get(`/minigames/table/${tableId}`)
  },
  shellGameSetup() {
    return instance.post('/minigames/shell-game/setup')
  },
  shellGameGuess(data) {
    return instance.post('/minigames/shell-game/guess', data)
  },

  // ─── Settings & Features ─────────────────────────────
  getFeatureStatus() {
    return instance.get('/settings/features')
  },
  getSettings(group) {
    return instance.get('/settings', { params: { group } })
  },
  updateSettings(settings) {
    return instance.put('/settings', { settings })
  },
  seedDefaultSettings() {
    return instance.post('/settings/seed-defaults')
  },
}
